import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, useLanguage } from "@/i18n/LanguageContext";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import ServicePage from "@/pages/ServicePage";
import AgentsServicePage from "@/pages/AgentsServicePage";
import AcademyPage from "@/pages/AcademyPage";
import ContattiPage from "@/pages/ContattiPage";

// Imposta la lingua in base al prefisso dell'URL (/de, /fr)
const LangGate = ({ lang, children }) => {
  const { lang: current, setLang } = useLanguage();
  useEffect(() => {
    if (current !== lang) setLang(lang);
  }, [lang, current, setLang]);
  return children;
};

const localizedRoutes = (lang) => [
  { path: "", el: <Landing /> },
  { path: "/privacy", el: <Privacy /> },
  { path: "/cookie-policy", el: <CookiePolicy /> },
  { path: "/blog", el: <Blog /> },
  { path: "/blog/:slug", el: <BlogArticle /> },
  { path: "/servizi/gestionali-su-misura", el: <ServicePage serviceId="gestionale" /> },
  { path: "/servizi/progettazione-impianti", el: <ServicePage serviceId="impianti" /> },
  { path: "/servizi/automazione-marketplace", el: <ServicePage serviceId="marketplace" /> },
  { path: "/servizi/agenti-ai-per-aziende", el: <AgentsServicePage /> },
  { path: "/academy", el: <AcademyPage /> },
  { path: "/contatti", el: <ContattiPage /> },
];

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/servizi/gestionali-su-misura" element={<ServicePage serviceId="gestionale" />} />
          <Route path="/servizi/progettazione-impianti" element={<ServicePage serviceId="impianti" />} />
          <Route path="/servizi/automazione-marketplace" element={<ServicePage serviceId="marketplace" />} />
          <Route path="/servizi/agenti-ai-per-aziende" element={<AgentsServicePage />} />
          <Route path="/academy" element={<AcademyPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          {["de", "fr"].map((lng) =>
            localizedRoutes(lng).map((r) => (
              <Route
                key={`${lng}${r.path || "/"}`}
                path={`/${lng}${r.path}`}
                element={<LangGate lang={lng}>{r.el}</LangGate>}
              />
            ))
          )}
        </Routes>
        <Toaster theme="dark" position="bottom-center" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
